<div style="max-width: 900px; margin: 30px auto;">
    <mat-card class="mb-20">
        <mat-card-header>
            <mat-card-title>Book Physical Appointment</mat-card-title>
            <mat-card-subtitle>Schedule an appointment for a patient present in the hospital.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="pt-20">
            <!-- Patient Search -->
            <div class="mb-20">
                <app-patient-filter></app-patient-filter>
            </div>

            <!-- Booking Form -->
            <form [formGroup]="bookingForm" (ngSubmit)="submitAppointment()" *ngIf="selectedPatientId">
                <div class="g-just-flex gap-20" style="align-items: flex-start; flex-wrap: wrap;">
                    
                    <mat-form-field appearance="outline" style="flex: 1; min-width: 250px;">
                        <mat-label>Select Practitioner</mat-label>
                        <input type="text" matInput [formControl]="practitionerSearchCtrl" [matAutocomplete]="practitionerAuto" placeholder="Search doctor...">
                        <mat-autocomplete #practitionerAuto="matAutocomplete" [displayWith]="displayPractitionerFn" (optionSelected)="onPractitionerSelected($event)">
                            @if(loadingPractitioners) {
                                <mat-option disabled>Loading practitioners...</mat-option>
                            } @else {
                                @for(p of filteredPractitioners; track p.id) {
                                    <mat-option [value]="p">
                                        <div style="display: flex; flex-direction: column; line-height: normal; padding: 8px 0;">
                                            <span>{{ p.name }}</span>
                                            <span style="font-size: 0.8em; color: var(--mat-sys-on-surface-variant); opacity: 0.8;">{{ p.roleDisplay }}</span>
                                        </div>
                                    </mat-option>
                                }
                            }
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="flex: 1; min-width: 250px;">
                        <mat-label>Task / Appointment Type</mat-label>
                        <mat-select formControlName="appointmentType">
                            @for(type of allowedAppointmentTypes; track type.code) {
                                <mat-option [value]="type.code">
                                    {{ type.display }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="flex: 1; min-width: 250px;">
                        <mat-label>Pick Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Slots -->
                @if(bookingForm.get('practitioner')?.value && bookingForm.get('appointmentType')?.value && bookingForm.get('date')?.value) {
                    <div class="mt-20">
                        <div class="section-title mb-10" style="font-weight: 500; font-size: 1rem; color: var(--mat-sys-primary)">
                            Available Slots
                        </div>
                        
                        @if(loadingSlots) {
                            <div class="small-subtitle">Searching for slots...</div>
                        } @else if(slots.length === 0) {
                            <div class="small-subtitle" style="color: var(--mat-sys-error)">No slots found for this criteria.</div>
                        } @else {
                            <mat-chip-listbox formControlName="slot">
                                @for(slot of slots; track slot.id) {
                                    <mat-chip-option [value]="slot.id">
                                        {{ formatSlotTime(slot) }}
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        }
                    </div>
                }

                <div class="mt-30 g-just-flex" style="justify-content: flex-end;">
                    <button mat-button type="button" routerLink="/app/appointments" class="me-10">Cancel</button>
                    <button mat-flat-button color="primary" type="submit" [disabled]="bookingForm.invalid || !selectedPatientId">
                        Confirm Appointment
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>